module.exports = __webpack_public_path__ + "static/RootSans-9Bold-2e6a2c0250b4beaf98e6efa8c84a316b.woff2";